<template>
  <div class="Instructions Page">
    <h1>{{ page.admin[lang].title }}</h1>
    <InstructionsBlock />
  </div>
</template>

<script>
import InstructionsBlock from '@/components/instructions-block/InstructionsBlock'
import Page from '@/core/mixins/Page'

export default {
  name: 'Instructions',
  mixins: [Page],
  components: { InstructionsBlock },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Instructions
  display block

</style>
